export default function FormSubmit($parse, $window) {
    'ngInject';

        return {
            restrict: 'A',
            require: 'form',
            link: function(scope, element, attributes, formController) {
                const submitFn = $parse(attributes.formSubmit);
                let headerHeight = 0;
                const submitSelector = 'button[inner-submit="true"]';
                const isInnerForm = element[0].nodeName === 'NG-FORM';

                function getHeaderHeight() {
                    headerHeight = headerHeight || angular.element('.app-header').height();
                    return headerHeight;
                }

                /**
                 * Scroll the form to the first invalid field
                 */
                function scrollToError() {
                    const $invalidWrapper = element.find('.ng-invalid').not('ng-form, :hidden').first();

                    if (!$invalidWrapper.length) {
                        return;
                    }

                    const invalidWrapperOffset = $invalidWrapper.offset().top - getHeaderHeight();
                    $window.scroll(0, invalidWrapperOffset);
                }

                /**
                 * Handle submit event
                 * The trick here is that there's no submit event on ng-form element,
                 * so we have to simulate it ourself, it will help a lot in case of nested forms
                 */
                if (!isInnerForm) {
                    element.on('submit', function(event) {
                        event.preventDefault();

                        // Submit all child forms
                        element.find('ng-form:not(.ng-hide)').addClass('ng-submitted');
                        for (const key in formController) {
                            if (key[0] !== '$' && angular.isObject(formController[key]) && angular.isDefined(formController[key].$submitted)) {
                                formController[key].$submitted = true;
                            }
                        }

                        if (!formController.$valid) {
                            scrollToError();
                        } else {
                            scope.$apply(function() {
                                submitFn(scope, {$event: event});
                            });
                        }
                    });
                } else {
                    formController.$refresh = function() {
                        formController.$setPristine();
                        formController.$setUntouched();
                        formController.$submitted = false;
                        element.removeClass('ng-submitted');
                    };
                    element.on('click', submitSelector, function(event) {
                        // In case on ng-form we need to set $submitted property to true manually
                        scope.$apply(function() {
                            formController.$submitted = true;
                            element.addClass('ng-submitted');

                            if (!formController.$valid) {
                                scrollToError();
                            } else {
                                submitFn(scope, {$event: event});
                            }
                        });
                    });
                }
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/directives/formSubmit.directive.js